import { createTracker } from 'usage-tracker-anonymous';
import { makeUuid } from 'usage-tracker-core/common/helpers';
import { getPortalInstanceId, getPortalName } from './metadata';
export const usageTracker = createTracker({
  allowUnauthed: true,
  standalone: true,
  properties: {
    deviceId: makeUuid,
    portalInstanceId: getPortalInstanceId(),
    portalAppName: getPortalName()
  }
});